<template>
    <div>
        <div v-if="isEnabled">
            <router-view></router-view>
        </div>
        <div v-else>
            <disabled-view></disabled-view>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex'

    import store from '@/stores/store'

    const publicStoreName = 'public'

    const landingBeforeRoute = async (to, from, next) => {
        if (to.params.id) {
            store.dispatch('session/setIsLoading', true)

            const landing = await store.dispatch('public/getLanding', to.params.id)

            store.dispatch('session/setIsLoading', false)

            if (!landing) {
                next({ name: 'PublicPageNotFound' })
            }
        }

        next()
    }

    export default {
        name: 'landing',

        props: {
            id: String
        },

        computed: {
            ...mapState(publicStoreName, [
                'landingLoaded', 
                'landing'
            ]),

            isEnabled() {
                return this.landing && this.landing.contactLanding.isEnabled
            }
        },

        async mounted() {
            this.setIsLoadingTheme(false)
        },

        async beforeRouteEnter (to, from, next) {
            await landingBeforeRoute(to, from, next)
        },

        async beforeRouteUpdate (to, from, next) {
            await landingBeforeRoute(to, from, next)
        }
    }

</script>